<template>
    <div class="takequiz">
    <h2> {{question.question}} </h2>
    <question-choice v-if="isChoice" @grade="gradeChoice" :answer="question.correctAnswer" :choices="question.choices" @selected-answer="selectedAnswer(currPoint)" />
    <free-throw v-if="isFreeThrow" @gradeFT="gradeChoice" :freeChoices="currentFreeThrow" />
    </div>
</template>
<script>
import QuestionChoice from './QuestionChoice'
import FreeThrow from './FreeThrow'
export default {
  name: 'Question',
  props: {
    question: {
      typs: Object
    }
  },
   data () {
    return {
      isFreeThrow: false,
      isChoice: true,
      currentFreeThrow: null
    }
   },
  methods: {
    getFreeThrow: function(){
      console.log('get the free throw');
      this.currentFreeThrow = this.question.freeThrows.pop()
    },
    gradeChoice: function(submit){
      return (submit.choice === submit.answer)? 
      this.showFreeThrow():
      this.$emit('choose-type')
    },
    showFreeThrow: function(){
      console.log('hide choices,show free throw')
      this.isFreeThrow = true;
      this.isChoice = false;
      this.getFreeThrow();
    }
  },
  components: {
    QuestionChoice,
    FreeThrow
  }
}
</script>

<style>

</style>
